const categoryType = {
  HCC: 1,
  ACA: 2
};

export default categoryType;
